import { getPgnRichTextVisibleText } from "~/components/pgn-rich-text/parsePgnRichText";

export const USER_COMMENT_SOURCE_LIMIT = 5000;

/** Keep editable source intact; validation and presentation share this policy. */
export function analyzeUserComment(source: string) {
  const normalized = source.replace(/\r\n?/g, "\n").trim();
  const length = normalized.length;
  if (length > USER_COMMENT_SOURCE_LIMIT) return { valid: false as const, length, userComment: null };
  return { valid: true as const, length,
    userComment: getPgnRichTextVisibleText(normalized).trim() ? normalized : null };
}

export function readUserComment(value: unknown): string | null {
  return typeof value === "string" ? analyzeUserComment(value).userComment : null;
}
